import { useDispatch, useSelector } from 'react-redux'

import { expert360ResSelector, setRes } from '../../../redux/reducers/Expert360/expert360.reducer'

import { formatNumbers } from '../../../utils/tsUtils'

export const useProductExpert360Count = () => {
  const dispatch: any = useDispatch()

  const res = useSelector(expert360ResSelector)

  const intensities = res?.countData?.client?.intensity ?? []
  const intensityId = res?.countData?.intensity ?? 2
  const customIntensity = intensities[3] ?? undefined

  const selectedIntensity = intensities.length > 0 && intensityId > 0 ? intensities[intensityId - 1] : null

  const selectedIntensityBudget = intensities.length > 0 && intensityId > 0
    ? formatNumbers(intensities?.[intensityId - 1]?.budget ?? 0)
    : '0'

  const handleChangeOfferType = (value: string) => {
    if (value === 'custom-offers') {
      dispatch(setRes({
        ...res,
        countData: {
          ...res.countData,
          intensity: 4,
        },
      }))
    } else {
      dispatch(setRes({
        ...res,
        countData: {
          ...res.countData,
          intensity: res?.countData?.client?.intensity?.[1]?.available ? 2 : 3,
        },
      }))
    }
  }

  return {
    customIntensity,
    selectedIntensity,
    selectedIntensityBudget,
    handleChangeOfferType,
  }
}
